import Plotly from 'plotly.js';

var HeatMap =
/** @class */
function () {
  function HeatMap(div, dp) {
    this.div = div;
    this.dp = dp;
  }

  HeatMap.prototype.dataUpdated = function () {
    var xValues = this.dp.X;
    var yValues = this.dp.Y;
    var zValues = this.dp.Z;
    var m = zValues.length;
    var n = zValues[0].length;
    var transposedZ = [];

    for (var i = 0; i < n; ++i) {
      transposedZ.push([]);

      for (var j = 0; j < m; ++j) {
        transposedZ[i].push(zValues[j][i]);
      }
    }

    var data = [{
      x: xValues,
      y: yValues,
      z: transposedZ,
      flipZ: true,
      type: 'heatmap',
      colorscale: 'Viridis'
    }];
    var layout = {
      plot_bgcolor: 'rgba(0,0,0,0)',
      paper_bgcolor: 'rgba(0,0,0,0)',
      autosize: true,
      margin: {
        l: 75,
        r: 0,
        b: 125,
        t: 16
      }
    };
    var config = {
      displayModeBar: false
    };
    Plotly.newPlot(this.div, data, layout, config);
  };

  return HeatMap;
}();

export { HeatMap };